import { TrainFront, HeartPulse, GraduationCap, HardHat, Landmark, Shield, Leaf, Zap, Scale, FileSearch, Droplets, Building2,
  Gavel, FileText, ShieldCheck, Newspaper, Megaphone, Image as ImageIcon } from "lucide-react";

const B = process.env.REACT_APP_BACKEND_URL;
export const abs = (u) => (u && u.startsWith("/api/") ? `${B}${u}` : u);

export const ISSUE_ICONS = { train: TrainFront, "heart-pulse": HeartPulse, "graduation-cap": GraduationCap, "hard-hat": HardHat,
  landmark: Landmark, shield: Shield, leaf: Leaf, zap: Zap, scale: Scale, "file-search": FileSearch, droplets: Droplets, building: Building2 };

export const RECORD_META = {
  pil: { icon: Scale, label: "PIL" },
  order: { icon: Gavel, label: "Court Order" },
  representation: { icon: FileText, label: "Representation" },
  official: { icon: ShieldCheck, label: "Official Document" },
  coverage: { icon: Newspaper, label: "Media Report" },
  press: { icon: Megaphone, label: "Press Release" },
  clip: { icon: ImageIcon, label: "Media Clip" },
};

export const STATUS_TONE = {
  court: "bg-sky-400", representation: "bg-amber-400", examination: "bg-npst-goldMuted", custom: "bg-emerald-400",
};

const STOP = new Set("the a an of in on for to and or is are was with about related show me find issues issue any what which who regarding".split(" "));

// Local AI-indexed search: scores AI-generated keywords, titles, categories and linked record titles.
export function searchIssues(issues, q) {
  const terms = q.toLowerCase().split(/[^a-z0-9\u0900-\u097F]+/).filter((t) => t.length > 1 && !STOP.has(t));
  if (!terms.length) return issues;
  return issues
    .map((i) => {
      const kw = (i.keywords || []).join(" ").toLowerCase();
      const title = `${i.title} ${i.category}`.toLowerCase();
      const recs = (i.record_titles || []).join(" ").toLowerCase();
      const score = terms.reduce((s, t) => s + (title.includes(t) ? 3 : 0) + (kw.includes(t) ? 2 : 0) + (recs.includes(t) ? 1 : 0)
        + (t.length > 4 && (kw + title).includes(t.slice(0, -1)) ? 0.5 : 0), 0);
      return { i, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((x) => x.i);
}

export const fmtDate = (d) => {
  if (!d) return "";
  const x = new Date(String(d).length === 10 ? `${d}T00:00:00` : d);
  return isNaN(x) ? String(d) : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
